export const DRAWER_OPEN_WIDTH_PX = '250px';
export const DRAWER_CLOSE_WIDTH_PX = '70px';

export const useSxStyles = () => {
  return {
    drawer: {
      position: 'relative',
      zIndex: 3,
      height: '100%',
      transition: 'width .2s ease-in-out',
      display: 'flex',
      flexDirection: 'column',
    },
    drawerOpen: {
      width: DRAWER_OPEN_WIDTH_PX,
    },
    drawerClose: {
      width: DRAWER_CLOSE_WIDTH_PX,
    },
    menuContent: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      height: 'inherit',
    },
    menuContentOpen: {
      transition: 'all .2s ease-in .2s',
      opacity: 1,
    },
    menuContentClose: {
      opacity: 0,
    },
    employeeMainData: { display: 'flex', flexDirection: 'column' },
    font: { fontSize: '22px', fontWeight: 700 },
    avatar: { minWidth: '100px', minHeight: '100px' },
    emptyMessage: { display: 'flex', flexGrow: 1 },
    iconButtonDiv: { display: 'flex', height: '50px' },
    iconButton: {
      marginLeft: 'auto',
      marginRight: '10px',
    },
    errorMessage: {
      margin: 'auto',
      textAlign: 'center',
    },
    addLinkContainer: {
      width: '100%',
    },
    buttonTextContainer: {
      width: '100%',
    },
    flipIcon: {
      transform: 'scaleX(-1)',
    },
  };
};
